import { render, staticRenderFns } from "./authority.vue?vue&type=template&id=7165699c&scoped=true&"
import script from "./authority.vue?vue&type=script&lang=js&"
export * from "./authority.vue?vue&type=script&lang=js&"
import style0 from "./authority.vue?vue&type=style&index=0&id=7165699c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7165699c",
  null
  
)

export default component.exports